export const publicContainer = {
  name: 'Public Container |||| Public Containers',
  fields: {
    title: 'Container Information',
    containerCode: 'Container code',
    totalShipments: 'Total shipments',
    totalWeight: 'Total weight',
    totalVolume: 'Total volume',
    shipmentsList: 'Shipments list',
    orderInfo: 'Order information',
    images: 'Images',
    notes: 'Notes',
    productName: 'Product name',
    numberOfPacks: 'Number of packs',
    totalDimension: 'Total dimension',
    totalWeightColumn: 'Total weight',
    status: 'Status',
    orderCreatedDate: 'Order created date',
    shipmentCreatedDate: 'Shipment created date',
    confirmationImage: 'Confirmation image',
    noImages: 'No images',
    noShipments: 'No shipments in this container.',
    invalidCode: 'Invalid or expired container code',
    missingCode: 'Container code not found in URL',
    loadingError: 'Error loading data',
    index: 'No.',
    mvd: 'MVD',
    order: 'Order',
    shipment: 'Shipment',
    inWarehouse: 'In warehouse',
  },
  statuses: {
    ALL: 'All',
    IN_FROM_WAREHOUSE: 'In source warehouse',
    TURN_AROUND: 'Turn around',
    LOADING: 'Loading',
    IN_CONT: 'In container',
    DEPARTED: 'Departed',
    ARRIVED: 'Arrived',
    RETURNED: 'Returned',
    IN_TO_WAREHOUSE: 'In destination warehouse',
    ON_DELIVERY: 'On delivery',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    LOST: 'Lost',
  },
}
